export enum LocalizationLabels {
  ExchangePhase = 'exchange.phase',
  ExchangePhaseSampleValue = 'exchange.phaseSampleValue',
}
